/**
 * Pure 2D vector utilities. Zero-safe normalize, deadzone, clamp.
 * No Phaser, no DOM. Consumed by InputSystem in Plan 03.
 */

export interface Vec2 {
  x: number
  y: number
}

export function length(v: Vec2): number {
  return Math.hypot(v.x, v.y)
}

/**
 * Returns unit-length vector in the same direction as v.
 * Zero-safe: normalize({0,0}) === {0,0}, never NaN.
 */
export function normalize(v: Vec2): Vec2 {
  const len = length(v)
  return len === 0 ? { x: 0, y: 0 } : { x: v.x / len, y: v.y / len }
}

/**
 * Collapse sub-threshold input to zero. Used for the 15% joystick deadzone
 * (CONTEXT.md Movement Feel). Strict less-than — threshold value itself passes.
 */
export function applyDeadzone(v: Vec2, threshold: number): Vec2 {
  return length(v) < threshold ? { x: 0, y: 0 } : v
}

export function clamp(n: number, min: number, max: number): number {
  return Math.min(Math.max(n, min), max)
}
